import React from 'react'
import Sboxprop from './Sboxprop'

function Sbox() {
    return (
        <>
            <Sboxprop />

        </>
    )
}

export default Sbox
